(function(window,document){
  'use strict';
  if(window.__jrJourneySimplifier)return;
  window.__jrJourneySimplifier=true;

  var CONFIG=window.JRX_CONFIG||{};
  var BOOKING=String(CONFIG.booking||'/pages/contact#jr-booking');
  var PATH=String(window.location.pathname||'').toLowerCase().replace(/\/$/,'');
  var STORAGE_KEY='jr_last_customer_intent';

  var LOCATION_BY_PATH={
    '/pages/calgary':'Calgary, AB',
    '/pages/airdrie':'Airdrie, AB',
    '/pages/chestermere':'Chestermere, AB',
    '/pages/cochrane':'Cochrane, AB',
    '/pages/northwest-calgary':'Northwest Calgary, AB',
    '/pages/northeast-calgary':'Northeast Calgary, AB',
    '/pages/southwest-calgary':'Southwest Calgary, AB',
    '/pages/southeast-calgary':'Southeast Calgary, AB'
  };
  var TYPE_BY_PATH={
    '/pages/detached-homes':'detached',
    '/pages/condos':'condo',
    '/pages/townhomes':'townhouse',
    '/pages/acreages':'acreage'
  };

  function text(node){return String((node&&node.textContent)||'').replace(/\s+/g,' ').trim();}
  function low(value){return String(value||'').toLowerCase();}
  function roots(){
    var found=[document],seen=[];
    function walk(root){
      if(!root||seen.indexOf(root)>-1)return;seen.push(root);
      try{root.querySelectorAll('*').forEach(function(node){if(node.shadowRoot){found.push(node.shadowRoot);walk(node.shadowRoot);}});}catch(e){}
    }
    walk(document);return found;
  }
  function all(selector){var out=[];roots().forEach(function(root){try{out=out.concat(Array.prototype.slice.call(root.querySelectorAll(selector)));}catch(e){}});return out;}
  function composedClosest(event,selector){
    var path=event.composedPath?event.composedPath():[];
    for(var i=0;i<path.length;i++){var node=path[i];if(node&&node.matches&&node.matches(selector))return node;}
    return event.target&&event.target.closest?event.target.closest(selector):null;
  }
  function safeUrl(href){try{return new URL(href||'',window.location.origin);}catch(e){return null;}}
  function intentFromText(value){
    value=low(value);var out={};
    if(/airdrie/.test(value))out.location='Airdrie, AB';
    else if(/chestermere/.test(value))out.location='Chestermere, AB';
    else if(/cochrane/.test(value))out.location='Cochrane, AB';
    else if(/northwest\s+calgary/.test(value))out.location='Northwest Calgary, AB';
    else if(/northeast\s+calgary/.test(value))out.location='Northeast Calgary, AB';
    else if(/southwest\s+calgary/.test(value))out.location='Southwest Calgary, AB';
    else if(/southeast\s+calgary/.test(value))out.location='Southeast Calgary, AB';
    else if(/calgary/.test(value))out.location='Calgary, AB';
    if(/detached|single[-\s]?family/.test(value))out.type='detached';
    else if(/condo|apartment/.test(value))out.type='condo';
    else if(/townhome|townhouse|row home/.test(value))out.type='townhouse';
    else if(/acreage|rural/.test(value))out.type='acreage';
    if(/luxury/.test(value))out.keywords='luxury';
    if(/open\s+house/.test(value))out.keywords='open house';
    if(/new\s+listing/.test(value))out.newListings=true;
    return out;
  }
  function merge(a,b){var out={};Object.keys(a||{}).forEach(function(k){if(a[k])out[k]=a[k];});Object.keys(b||{}).forEach(function(k){if(b[k])out[k]=b[k];});return out;}
  function contextFor(anchor){
    var ctx={location:LOCATION_BY_PATH[PATH]||'',type:TYPE_BY_PATH[PATH]||'',keywords:'',newListings:false};
    if(PATH==='/pages/luxury-homes')ctx.keywords='luxury';
    if(PATH==='/pages/open-houses')ctx.keywords='open house';
    if(PATH==='/pages/new-listings')ctx.newListings=true;
    var label=text(anchor);
    ctx=merge(ctx,intentFromText(label));
    var url=safeUrl(anchor&&anchor.getAttribute&&anchor.getAttribute('href'));
    if(url&&url.origin===window.location.origin){
      var targetPath=url.pathname.toLowerCase().replace(/\/$/,'');
      if(LOCATION_BY_PATH[targetPath])ctx.location=LOCATION_BY_PATH[targetPath];
      if(TYPE_BY_PATH[targetPath])ctx.type=TYPE_BY_PATH[targetPath];
      if(targetPath==='/pages/luxury-homes')ctx.keywords='luxury';
      if(targetPath==='/pages/open-houses')ctx.keywords='open house';
      if(targetPath==='/pages/new-listings')ctx.newListings=true;
    }
    return ctx;
  }
  function buildSearchUrl(ctx,opts){
    ctx=ctx||{};opts=opts||{};
    var url=new URL('/pages/property-search',window.location.origin);
    url.searchParams.set('q',ctx.location||'Calgary, AB');url.searchParams.set('cities',(ctx.location||'Calgary, AB').split(',')[0].trim());
    url.searchParams.set('province','AB');
    url.searchParams.set('market','residential');
    url.searchParams.set('residential','1');
    url.searchParams.set('status','sale');
    url.searchParams.set('transaction','sale');
    url.searchParams.set('sort','6-D');
    if(ctx.type)url.searchParams.set('property_type',ctx.type);
    if(ctx.keywords)url.searchParams.set('keywords',ctx.keywords);
    if(ctx.newListings)url.searchParams.set('new_listings','1');
    if(opts.saveSearch)url.searchParams.set('save_search','1');
    if(opts.showing)url.searchParams.set('showing','1');
    if(opts.listing)url.searchParams.set('listing',String(opts.listing).slice(0,220));
    return url.pathname+url.search+(opts.anchor||'');
  }
  function pageIntent(label){
    var value=low(label+' '+PATH);
    if(/sell|seller|valuation|home-value|list-with-me|marketing/.test(value))return 'seller';
    if(/relocat/.test(value))return 'relocation';
    if(/invest/.test(value))return 'investment';
    if(/showing|property|listing|buyer|buy|dream-home/.test(value))return 'buyer';
    return 'general';
  }
  function rememberIntent(kind,anchor,extra){
    var payload={kind:kind,intent:pageIntent(text(anchor)),label:text(anchor),path:PATH,time:new Date().toISOString(),context:contextFor(anchor)};
    if(extra)Object.keys(extra).forEach(function(k){payload[k]=extra[k];});
    try{sessionStorage.setItem(STORAGE_KEY,JSON.stringify(payload));localStorage.setItem(STORAGE_KEY,JSON.stringify(payload));}catch(e){}
    if(window.jrxTrack)window.jrxTrack(kind,{intent:payload.intent,label:payload.label,path:PATH,context:payload.context});
  }
  function isBookingLabel(label){
    label=low(label);
    if(/showing/.test(label))return false;
    return /(book|schedule|request)\s+(a\s+)?(private\s+)?(buyer\s+|seller\s+|listing\s+|pricing\s+|real\s+estate\s+)?(consultation|appointment|strategy\s+session|call)/.test(label)
      || /speak\s+with\s+jasjeet|start\s+a\s+conversation|work\s+with\s+me|ask\s+jasjeet/.test(label);
  }
  function isAlertLabel(label){return /(get|receive|create|request)?\s*(home|listing|property|price)?\s*alerts?|save\s+(this|my|the)\s+search/.test(low(label));}
  function isSearchLabel(label){return /(search|browse|view)\s+.*(home|listing|propert)|start\s+(your\s+)?home\s+search|browse\s+all\s+listings/.test(low(label));}
  function isShowingLabel(label){return /(book|request|schedule).*(showing|tour)|see\s+it\s+in\s+person/.test(low(label));}

  function prepareAnchor(anchor){
    if(!anchor||anchor.dataset.jrJourneyReady==='true')return;
    var label=text(anchor),href=anchor.getAttribute('href')||'';
    if(!label)return;
    if(/^tel:|^sms:|^mailto:|^#/.test(href)){
      anchor.dataset.jrJourneyReady='true';return;
    }
    if(isBookingLabel(label)&&BOOKING){
      anchor.setAttribute('href',BOOKING);
      anchor.setAttribute('data-jrx-track','schedule');
      anchor.setAttribute('data-jr-intent',pageIntent(label));
      anchor.dataset.jrJourneyKind='booking';
    }else if(isAlertLabel(label)&&!anchor.hasAttribute('data-save-search-open')){
      anchor.setAttribute('href',buildSearchUrl(contextFor(anchor),{saveSearch:true,anchor:'#live-search'}));
      anchor.setAttribute('data-jrx-track','saved_search_open');
      anchor.dataset.jrJourneyKind='alert';
    }else if(isShowingLabel(label)&&PATH!=='/pages/property-search'){
      var listing=anchor.getAttribute('data-jrx-addr')||anchor.getAttribute('data-listing')||'';
      anchor.setAttribute('href',buildSearchUrl(contextFor(anchor),{showing:true,listing:listing,anchor:'#book'}));
      anchor.setAttribute('data-jrx-track','showing_form_open');
      anchor.dataset.jrJourneyKind='showing';
    }else if(isSearchLabel(label)){
      var parsed=safeUrl(href);
      var internalSearch=parsed&&parsed.origin===window.location.origin&&(/\/pages\/property-search/.test(parsed.pathname)||LOCATION_BY_PATH[parsed.pathname.toLowerCase().replace(/\/$/,'')]||TYPE_BY_PATH[parsed.pathname.toLowerCase().replace(/\/$/,'')]);
      if(internalSearch){
        anchor.setAttribute('href',buildSearchUrl(contextFor(anchor),{anchor:'#live-search'}));
        anchor.setAttribute('data-jrx-track','property_search_open');
        anchor.dataset.jrJourneyKind='search';
      }
    }
    if(anchor.hasAttribute('data-track')&&!anchor.hasAttribute('data-jrx-track'))anchor.setAttribute('data-jrx-track',anchor.getAttribute('data-track'));
    anchor.dataset.jrJourneyReady='true';
  }
  function prepareForms(){
    all('form').forEach(function(form){
      if(form.dataset.jrJourneyForm==='true')return;
      form.dataset.jrJourneyForm='true';
      var stored='';try{stored=sessionStorage.getItem(STORAGE_KEY)||localStorage.getItem(STORAGE_KEY)||'';}catch(e){}
      if(stored){
        var input=form.querySelector('input[name="contact[Visitor intent]"]');
        if(!input){input=document.createElement('input');input.type='hidden';input.name='contact[Visitor intent]';form.appendChild(input);}
        input.value=stored.slice(0,1400);
      }
    });
  }
  function markPrimaryActions(){
    roots().forEach(function(root){
      try{
        if(root.querySelector('[data-jr-primary-action]'))return;
        var candidates=Array.prototype.slice.call(root.querySelectorAll('a,button')).filter(function(node){
          var label=text(node);return isSearchLabel(label)||isBookingLabel(label)||/home\s+value|valuation/.test(low(label));
        });
        if(candidates[0])candidates[0].setAttribute('data-jr-primary-action','true');
      }catch(e){}
    });
  }
  function scan(){all('a').forEach(prepareAnchor);prepareForms();markPrimaryActions();}

  document.addEventListener('click',function(event){
    var anchor=composedClosest(event,'a');if(!anchor)return;
    prepareAnchor(anchor);
    var kind=anchor.dataset.jrJourneyKind;
    if(kind)rememberIntent(kind,anchor);
    else if(anchor.hasAttribute('data-track')&&window.jrxTrack){window.jrxTrack(anchor.getAttribute('data-track')||'engagement',{lead_type:anchor.getAttribute('data-lead-type')||'',crm_tags:anchor.getAttribute('data-crm-tags')||'',label:text(anchor),path:PATH});}
  },true);

  function boot(){scan();[120,450,1000,2200,4500,8000].forEach(function(delay){setTimeout(scan,delay);});
    try{var pending=false;var mo=new MutationObserver(function(){if(pending)return;pending=true;setTimeout(function(){pending=false;scan();},80);});mo.observe(document.documentElement,{childList:true,subtree:true});setTimeout(function(){mo.disconnect();},12000);}catch(e){}
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})(window,document);
